import { createBrowserRouter } from 'react-router'
import { Layout as RootLayout } from '@/core/layout'
import { Index as DashboardIndex } from '@/pages/dashboard/index'
import { Layout as EventsLayout } from '@/pages/events/layout'
import { Layout as ClientsLayout } from '@/pages/clients/layout'
import { Index as VenuesIndex } from '@/pages/events/venues'
import { Index as EventsIndex } from '@/pages/events/events'
import { Index as AccommodationsIndex } from '@/pages/events/accommodations'
import { Index as InboxIndex } from '@/pages/inbox/index'
import { Index as ClientsIndex } from '@/pages/clients/index'
import { Layout as InboxLayout } from '@/pages/inbox/layout'
import { Index as SettingsIndex } from '@/pages/settings/index'
import { CompanyDetails as SettingsCompanyDetails } from '@/pages/settings/company_details'
import { TaxRates as SettingsTaxRates } from '@/pages/settings/tax_rates'
import { Integrations as SettingsIntegrations } from '@/pages/settings/integrations'
import { MaintenanceSchedules as SettingsMaintenanceSchedules } from '@/pages/settings/maintenance_schedules'
import { MaintenanceTypes as SettingsMaintenanceTypes } from '@/pages/settings/maintenance_types'
import { ChargeMultipliers as SettingsChargeMultipliers } from '@/pages/settings/charge_multipliers'
import { Categories as SettingsCategories } from '@/pages/settings/categories'
import { Warehouses as SettingsWarehouses } from '@/pages/settings/warehouses'
import { ClientTypes as SettingsClientTypes } from '@/pages/settings/client_types'
import { DocumentTypes as SettingsDocumentTypes } from '@/pages/settings/document_types'
import { CustomFields as SettingsCustomFields } from '@/pages/settings/custom_fields'
import { Imports as SettingsImports } from '@/pages/settings/imports'
import { Layout as SettingsLayout } from '@/pages/settings/layout'
import { NotFound } from '@/components/error'
import { Layout as DocumentsLayout } from '@/pages/documents/layout'
import { Layout as MaintenanceLayout } from '@/pages/maintenance/layout'
import { Index as DocumentsIndex } from '@/pages/documents/index'
import { Layout as EquipmentLayout } from '@/pages/equipment/layout'
import { Layout as WebsiteLayout } from '@/pages/website/layout'
import { Index as AssetTypesIndex } from '@/pages/equipment/asset_types'
import { Index as AssetIndex } from '@/pages/equipment/assets'
import { Index as PackageIndex } from '@/pages/equipment/packages'
import { Index as RowItemIndex } from '@/pages/equipment/row_items'
import { Index as VehicleIndex } from '@/pages/equipment/vehicles'
import { Index as AssetCaseIndex } from '@/pages/equipment/asset_cases'
import { Index as MaintenanceEventIndex } from '@/pages/maintenance/index'
// import { Index as WebsiteIndex } from '@/pages/website/index'
import { Index as PortfolioPageIndex } from '@/pages/website/portfolio'
import { Users } from './pages/settings/users'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFound />,
    children: [
      {
        errorElement: <NotFound />,
        children: [
          { index: true, element: <DashboardIndex /> },
          {
            path: 'inbox',
            element: <InboxLayout />,
            children: [
              { index: true, element: <InboxIndex /> },
              { path: ':id', element: <InboxIndex /> },
              { path: 'read', element: null }
            ]
          },
          {
            path: 'events',
            element: <EventsLayout />,
            children: [
              { index: true, element: <EventsIndex /> },
              { path: ':id', element: <EventsIndex /> }
            ]
          },
          {
            path: 'venues',
            element: <EventsLayout />,
            children: [
              { index: true, element: <VenuesIndex /> },
              { path: ':id', element: <VenuesIndex /> },
            ]
          },
          {
            path: 'clients',
            element: <ClientsLayout />,
            children: [
              { index: true, element: <ClientsIndex /> },
              { path: ':id', element: <ClientsIndex /> }
            ]
          },
          {
            path: 'documents',
            element: <DocumentsLayout />,
            children: [
              { index: true, element: <DocumentsIndex /> },
              { path: ':id', element: <DocumentsIndex /> }
            ]
          },
          {
            path: 'asset-types',
            element: <EquipmentLayout />,
            children: [
              { index: true, element: <AssetTypesIndex /> },
              { path: ':id', element: <AssetTypesIndex /> }
            ]
          },
          {
            path: 'maintenance',
            element: <MaintenanceLayout />,
            children: [
              { index: true, element: <MaintenanceEventIndex /> },
              { path: ':id', element: <MaintenanceEventIndex /> }
            ]
          },
          {
            path: 'assets',
            element: <EquipmentLayout />,
            children: [
              { index: true, element: <AssetIndex /> },
              { path: ':id', element: <AssetIndex /> }
            ]
          },
          {
            path: 'packages',
            element: <EquipmentLayout />,
            children: [
              { index: true, element: <PackageIndex /> },
              { path: ':id', element: <PackageIndex /> }
            ]
          },
          {
            path: 'extra-items',
            element: <EquipmentLayout />,
            children: [
              { index: true, element: <RowItemIndex /> },
              { path: ':id', element: <RowItemIndex /> }
            ]
          },
          {
            path: 'vehicles',
            element: <EquipmentLayout />,
            children: [
              { index: true, element: <VehicleIndex /> },
              { path: ':id', element: <VehicleIndex /> }
            ]
          },
          {
            path: 'cases',
            element: <EquipmentLayout />,
            children: [
              { index: true, element: <AssetCaseIndex /> },
              { path: ':id', element: <AssetCaseIndex /> }
            ]
          },
          {
            path: 'accommodation',
            element: <EventsLayout />,
            children: [
              { index: true, element: <AccommodationsIndex /> },
              { path: ':id', element: <AccommodationsIndex /> }
            ]
          },
          // {
          //   path: 'website',
          //   element: <WebsiteLayout />,
          //   children: [
          //     { index: true, element: <WebsiteIndex /> },
          //     { path: ':id', element: <WebsiteIndex /> }
          //   ]
          // },
          {
            path: 'portfolio',
            element: <WebsiteLayout />,
            children: [
              { index: true, element: <PortfolioPageIndex /> },
              { path: ':id', element: <PortfolioPageIndex /> }
            ]
          },
          {
            path: 'settings',
            element: <SettingsLayout />,
            children: [
              { index: true, element: <SettingsIndex /> },
              { path: 'company-details', element: <SettingsCompanyDetails /> },
              { path: 'users', element: <Users /> },
              {
                path: 'integrations',
                children: [
                  { index: true, element: <SettingsIntegrations /> },
                  { path: ':id', element: <SettingsIntegrations /> }
                ]
              },
              {
                path: 'tax-rates',
                children: [
                  { index: true, element: <SettingsTaxRates /> },
                  { path: ':id', element: <SettingsTaxRates /> }
                ]
              },
              {
                path: 'maintenance-schedules',
                children: [
                  { index: true, element: <SettingsMaintenanceSchedules /> },
                  { path: ':id', element: <SettingsMaintenanceSchedules /> }
                ]
              },
              {
                path: 'charge-multipliers',
                children: [
                  { index: true, element: <SettingsChargeMultipliers /> },
                  { path: ':id', element: <SettingsChargeMultipliers /> }
                ]
              },
              {
                path: 'maintenance-types',
                children: [
                  { index: true, element: <SettingsMaintenanceTypes /> },
                  { path: ':id', element: <SettingsMaintenanceTypes /> }
                ]
              },
              { path: 'client-types', element: <SettingsClientTypes /> },
              {
                path: 'categories',
                children: [
                  { index: true, element: <SettingsCategories /> },
                  { path: ':id', element: <SettingsCategories /> }
                ]
              },
              {
                path: 'warehouses',
                children: [
                  { index: true, element: <SettingsWarehouses /> },
                  { path: ':id', element: <SettingsWarehouses /> }
                ]
              },
              {
                path: 'document-types',
                children: [
                  { index: true, element: <SettingsDocumentTypes /> },
                  { path: ':id', element: <SettingsDocumentTypes /> }
                ]
              },
              {
                path: 'custom-fields',
                children: [
                  { index: true, element: <SettingsCustomFields /> },
                  { path: ':id', element: <SettingsCustomFields /> }
                ]
              },
              { path: 'imports', element: <SettingsImports /> },
            ]
          },
        ]
      },
    ]
  },
])
